import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import { CustomValidators } from '../../../../services/helpers/form-custom-validators';
import { SSO_REMOVAL_REASON_CHAR_LIMIT } from '../../../../../../shared/constants/tenant';

import { IModal } from '../../../../components/modals/modal.interface';
import { ModalContainerComponent } from '../../../../components/modals/modal-container.component';

enum FORM_FIELDS {
  confirmed = 'confirmed',
  reason = 'reason',
}

@Component({
  selector: 'app-tenant-remove-sso-modal',
  templateUrl: './tenant-remove-sso-modal.component.html',
  styleUrls: ['./tenant-remove-sso-modal.component.scss'],
  standalone: false,
})
export class TenantRemoveSsoModalComponent implements IModal {
  public form: UntypedFormGroup;
  public FORM_FIELDS: typeof FORM_FIELDS = FORM_FIELDS;
  public formValidationRequest$: Subject<void> = new Subject<void>();

  public reasonCharLimit: number = SSO_REMOVAL_REASON_CHAR_LIMIT;

  @Input() tenantName: string = '';
  @Output() confirmed: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;

  constructor(private formBuilder: UntypedFormBuilder) {
    this.form = this.createForm();
  }

  private createForm(): UntypedFormGroup {
    const config: Record<string, UntypedFormControl> = {
      [FORM_FIELDS.confirmed]: new UntypedFormControl(false, Validators.requiredTrue),
      [FORM_FIELDS.reason]: new UntypedFormControl(null, [
        CustomValidators.validateIsEmpty,
        CustomValidators.required,
        Validators.maxLength(SSO_REMOVAL_REASON_CHAR_LIMIT),
      ]),
    };

    return this.formBuilder.group(config);
  }

  public removeSso(): void {
    this.confirmed.emit(this.form.get(FORM_FIELDS.reason).value);
    this.container.closeModal();
  }
}
